import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { ReclamationActionDetailType } from 'constants.js';
import stringHelper from 'utils/stringHelper';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import { ReclamationActionDetailCodes } from 'constants.js';

const styles = theme => ({
    formControl: {
        width: '100%'
    },

    detailValue: {
        paddingLeft: theme.spacing(4)
    }    
});

class RenvoyerMarchandiseDialogContent extends React.Component {

    state = {
        numeroPiece: ''
    };

    componentDidMount() {
        this.props.onChange(null);
    }

    getActionData(newState) {
        const { action} = this.props;

        if (stringHelper.isNullOrWhitespace(newState.numeroPiece)) {
            return null;
        }

        let actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.NumeroPiece,
                type: ReclamationActionDetailType.Texte,
                libelle: "Numéro de pièce",
                position: 0,
                valeurString: newState.numeroPiece
            }]
        };

        return actionData;
    }

    handleChange = (event) => {

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }

    render() {
        const { classes } = this.props;
        const { numeroPiece } = this.state;

        return (
            <DialogContent>
                <TextField className={classes.formControl}
                    required
                    id="numeroPiece"
                    name="numeroPiece"
                    label="Numéro de pièce (prépa ou BL)"
                    placeholder="Numéro de pièce"
                    multiline
                    margin="normal"
                    value={numeroPiece}
                    onChange={this.handleChange}
                />
            </DialogContent>
        );
    }
}

RenvoyerMarchandiseDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

export default withStyles(styles)(RenvoyerMarchandiseDialogContent);